import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { HttpService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { Inject } from '@odinjs/odin';
import { InputAPI, LinkAPI, BaseModalProps, ModalService } from '@philips-internal/oswald-ui-components';
import { ModalButtonType } from '@philips-internal/oswald-ui-constants';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import BaseController from '../BaseController';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import './index.css';

@Controller({ fragment: 'user-profile', component: 'layout-profile' })
export default class UserProfileController extends BaseController {

  @Inject('situation-input')
  situation: InputAPI;

  @Inject('user-input')
  user: InputAPI;

  @Inject('login-input')
  login: InputAPI;

  @Inject('type-access-input')
  type: InputAPI;

  @Inject('link-situation')
  linkSituation: LinkAPI;

  @OnMount({ target: 'layout-profile' })
  OnFilterMout(): void {

    const { nmPhysicalPerson, dsLogin, type, situationDesc, ativado } = this.historyService.getCurrentRouteQueryParams() as Record<string,string>;

    this.user.setValue(nmPhysicalPerson);
    this.login.setValue(dsLogin);
    this.type.setValue(type);
    this.situation.setValue(situationDesc);

    if (Number(ativado) === 0) {
      this.linkSituation.setValue('');
    }
  }

  @OnClick({ target: 'link-situation' })
  onClickSituation(): void {
    const { situation, nrSequence } = this.historyService.getCurrentRouteQueryParams();
    const sequence = nrSequence as string;
    const situationActual = situation as string;
    const modalProps: BaseModalProps = {
      title: MessageService.translate('results.informations'),
      fragment: 'modal-active',
      focusOnOpen: true,
      contextData: { situationActual },
      dockButtons: [
        {
          action: () => void {},
          title: MessageService.translate('result.form.cancel'),
          type: ModalButtonType.CANCEL
        },
        {
          action: () => {this.updateUser(sequence, situationActual)},
          title: MessageService.translate('results.ok'),
          type: ModalButtonType.SUCCESS
        }
      ]
    };

    ModalService.openDefault(modalProps);
  }

  updateUser(nrSequence: string, situationActual: string): void {
    const updatedSituation = situationActual == 'I' ? 'A': 'I';
    HttpService.put(APPLICATION_ENDPOINTS.ACTIVATE_USER, { nrSequence, updatedSituation }).then(() => {
      applicationContext.redirect(APPLICATION_ROUTES.USERS);
    });
  }

}
